module.exports = __webpack_public_path__ + "img/loyalty-reward-item.2bddb806.svg";